var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fe-remote-combo',_vm._g(_vm._b({staticStyle:{"width":"100%"},attrs:{"byId":"","items":_vm.statuses,"value":_vm.statusId},on:{"input":_vm.setStatus}},'fe-remote-combo',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }